export const DEAL_PROPERTY_NAMES = {
  AMOUNT: 'amount',
  DEAL_NAME: 'dealname',
  DEAL_TAGS: 'hs_tag_ids',
  FORECAST_AMOUNT: 'hs_forecast_amount',
  FORECAST_PROBABILITY: 'hs_forecast_probability'
};